var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.modalName,{tag:"component",attrs:{"modal-mixin-show":_vm.show},on:{"close":_vm.hideModal,"confirm":_vm.confirmModal}})}
var staticRenderFns = []

export { render, staticRenderFns }